import BlockCard from './BlockCard';

export default function BlockList({ blocks, onUpdate, onRemove, onMove, onToggleVisibility, expandedBlockId }) {
  if (blocks.length === 0) return null;

  return (
    <div className="pagebuilder-block-list">
      {blocks.map((block, idx) => (
        <BlockCard
          key={block.id}
          block={block}
          index={idx}
          total={blocks.length}
          onUpdate={onUpdate}
          onRemove={onRemove}
          onMove={onMove}
          onToggleVisibility={onToggleVisibility}
          expandedBlockId={expandedBlockId}
          scrollToBottomOnExpand={expandedBlockId === block.id}
        />
      ))}
    </div>
  );
}
